(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.cmpInit === '1') return;
      root.dataset.cmpInit = '1';

      /* Imagen sincronizada con la variante (radios o selects de cualquier tema) */
      var mapEl = root.querySelector('[data-cmp-variant-images]');
      var img = root.querySelector('[data-cmp-product-img]');
      if (mapEl && img) {
        var map = {};
        try { map = JSON.parse(mapEl.textContent); } catch (e) {}
        document.addEventListener('change', function (e) {
          var t = e.target;
          if (!t || !t.matches || !t.matches('input[type="radio"], select')) return;
          if (!t.closest('form[action*="/cart/add"], variant-selects, variant-radios, variant-picker, .product-form, .product-info, [data-product-form]') && !t.form) return;
          var entry = map[String(t.value || '').toLowerCase().trim()];
          if (!entry) return;
          img.srcset = entry.srcset;
          img.src = entry.src;
        });
      }

      /* Popup */
      var popup = root.querySelector('[data-cmp-popup]');
      var openBtn = root.querySelector('[data-cmp-open]');
      if (popup && openBtn) {
        if (popup.parentNode !== document.body) document.body.appendChild(popup);
        var open = function () {
          popup.classList.add('is-open');
          popup.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var c = popup.querySelector('.cmp-popup__close');
          if (c) c.focus();
        };
        var close = function () {
          popup.classList.remove('is-open');
          popup.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          openBtn.focus();
        };
        openBtn.addEventListener('click', open);
        popup.querySelectorAll('[data-cmp-close]').forEach(function (el) { el.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
        });
      }
    }

    document.querySelectorAll('[data-cmp-root]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-cmp-root]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
